import Image from "next/image";
import Modal from "../../molecules/modal/modal";
import Link from "next/link";
import { Form, Formik } from "formik";
import FormText from "../../atoms/form-text/form-text";
import ButtonPrimary from "../../atoms/button-primary/button-primary";
import client from "../../../services/customer-api/client";
import useGetSessionId from '../../providers/user/hooks/use-get-session-id.hook';
import { useContext, useEffect, useState } from "react";
import { OverlayDispatchContext } from "../../providers/overlay/overlay.provider";
import close from "../../providers/overlay/close.overlay.actions";
import useUser from "../../providers/user/hooks/use-user.hook";

const NotifyProductItem = ({product}) => {
  console.log("product: ", product)
  const {name, variantSku, url} = product
  const {webImageSmall60} = product.properties

  return (
    <div className="bg-[#F2F2F2] flex gap-5 p-2 rounded-md mt-5" style={{backgroundColor: "#F2F2F2"}}>
      <div className="w-[64px] h-[64px] overflow-hidden rounded-md">
        {webImageSmall60 ? (
          <Image src={webImageSmall60} width={64} height={64} />
        ) : (<div className="w-16 h-16 bg-grey-200 rounded-md"></div>)}
      </div>

      <div className="">
        <p className="font-bold text-md">{name}</p>
        <Link href={url}>
          <a className="text-blue-500 text-sm">{variantSku}</a>
        </Link>
      </div>
    </div>
  )
}

const NotifyMeModal = ({product, sessionId}) => {
  const user = useUser();
  
  const [emailValue, setEmailValue] = useState("");

  const [ notificationSubmissionState, setNotificationSubmissionState ] = useState(false)
    const overlayDispatch = useContext(OverlayDispatchContext);

  const createStockNotification = async (email: string) => {

    if (!sessionId) return;

    try {
     await client.options(
      '/user/back-in-stock-notification'
    ).then(async response => {
      if (response.status === 200) {
        await client.post('/user/back-in-stock-notification',  {
        sessionId: sessionId,
        email: email,
        productNumber: product.properties?.internalRef,
        stockQuantity: 1,
        accountNumber: user ? user.accountNumber : 999998
      }).then(reqStatus => {
        if (reqStatus.status === 200) {
          setNotificationSubmissionState(true)
        }
      })
      }
    });
    } catch (error) {
      console.log("error: ", {error})
    }
  }
  return (
    <Modal customStyles={{width: '615px', height: 'auto', maxHeight: '500px'}}>
      <div className="">
        <h4 className="page-heading-four">
          Lead Times
        </h4>
        
        <NotifyProductItem product={product} />

        <div className="w-full mt-5">
          <Formik initialValues={{ email: '' }} onSubmit={(ev) => {createStockNotification(ev.email); setEmailValue(ev.email)}}>
            {(formikProps) => {
              return (
                <Form className="w-full flex gap-2">
                  <div className="w-full h-[52px]">
                    <FormText name={'email'} label={null} placeholder="E-Mail" className="py-0" />
                  </div>
                  <div className="h-[52px] text-white">
                    <button className="text-white h-[52px] rounded-lg p-5" style={{backgroundColor: "#0075BF"}}>Confirm</button>
                  </div>
                </Form>
            )}}
          </Formik>

          {notificationSubmissionState && (
            <div className="flex flex-col gap-5 mt-9">
              <div className="bg-yellow-500 flex flex-row gap-5 p-4" style={{backgroundColor: "#FCFAF1"}}>
                <div></div>
                <p>We will notify {emailValue} when this product is back in stock.</p>
              </div>
              <button className="block m-auto text-french-blue" onClick={() => {
                setNotificationSubmissionState(false); 
                setEmailValue("")
                overlayDispatch(close()); 
              }}>Close</button>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default NotifyMeModal;